enum RouteNames {
  Home = '/',
  Blog = '/blog',
  Contact = '/contact',
}

export default RouteNames;
